import type { CSSProperties } from "react";

import type { BubbleAxisAnchor, BubblePosition } from "../types";

const horizontalStyle = (anchor: BubbleAxisAnchor, halfBubble: number): CSSProperties => {
  switch (anchor.type) {
    case "start":
      return { left: anchor.offset };
    case "end":
      return { right: anchor.offset };
    case "fraction":
      return { left: `calc(${anchor.value * 100}% - ${halfBubble}px)` };
  }
};

const verticalStyle = (anchor: BubbleAxisAnchor, halfBubble: number): CSSProperties => {
  switch (anchor.type) {
    case "start":
      return { top: anchor.offset };
    case "end":
      return { bottom: anchor.offset };
    case "fraction":
      return { top: `calc(${anchor.value * 100}% - ${halfBubble}px)` };
  }
};

export const getBubbleAnchorStyle = (position: BubblePosition, halfBubble: number): CSSProperties => ({
  ...horizontalStyle(position.horizontal, halfBubble),
  ...verticalStyle(position.vertical, halfBubble)
});
